/******************
	Simple util to make checking, setting, and deleting cookie values easy.
	- The get() method returns false if no cookie by that name has been set, or the value if it has been set.
	- The others do what you would expect based on the names.
	ex:
	this.$cookie.set("cookieNameGoesHere", "cookieValueGoesHere", 1000) >> where 1000 is the number of days until the cookie expires
	this.$cookie.get("cookieNameGoesHere") >> returns "cookieValueGoesHere"
	this.$cookie.delete("cookieNameGoesHere") >> expiration date set to date in the past, which makes the browser treat it as expired, thus removing it
	this.$cookie.get("cookieNameGoesHere") >> returns false
******************/

const cookie = {
	get(name) {
		name += "=";
		let cookieArray = decodeURIComponent(document.cookie).split(';');
		for(let i = 0; i < cookieArray.length; i++) {
			let c = cookieArray[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return false;
	},
	set(name, value, daysToExp) {
		let d = new Date();
		d.setTime(d.getTime() + (daysToExp*24*60*60*1000));
		document.cookie = name + "=" + value + ";expires="+ d.toUTCString() + ";path=/";
	},
	delete(name) {
		let d = new Date("01/01/2000");
		document.cookie = name + "=null;expires="+ d.toUTCString() + ";path=/";
	},
	deleteAll() {
		let cookieArray = decodeURIComponent(document.cookie).split(';');
		let cookieNameArray = cookieArray.map(c => c.split("=")[0]);
		cookieNameArray.forEach(c => this.delete(c));
	}
}

export default cookie;
